// The checkout attempt id has to survive the gateway redirect: /payment-response is a fresh
// page load carrying only `gateway_ref_id`, so the payment step stashes the attempt id under
// that ref and the response page reads it back to rejoin the same trace.
//
// ponytail: sessionStorage, never swept — it dies with the tab and holds two short strings.
const ATTEMPT_KEY_PREFIX = 'fg:attempt:'

// crypto.randomUUID() only exists in a secure context, and the per-branch EC2 test env is not
// guaranteed to be one. A missing trace id must never break a payment, so fall back.
export const newAttemptId = (): string =>
    typeof crypto?.randomUUID === 'function' ? crypto.randomUUID() : `fg-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`

export const rememberAttempt = (gatewayRefId: string, attemptId: string): void => {
    if (!gatewayRefId || !attemptId) return
    try {
        sessionStorage.setItem(ATTEMPT_KEY_PREFIX + gatewayRefId, attemptId)
    } catch {
        /* storage unavailable — the trace just loses its redirect hop */
    }
}

export const recallAttempt = (gatewayRefId: string): string | undefined => {
    try {
        return sessionStorage.getItem(ATTEMPT_KEY_PREFIX + gatewayRefId) || undefined
    } catch {
        return undefined
    }
}
